import { useClusterDraftPrice } from '../../hooks/useClusterDraftPrice';
import { useEditClusterPrice } from '../../hooks/useEditClusterPrice';
import { useNetworkPricesStore } from '../../NetworkPrices.store';
import { NetworkPriceCluster, NetworkPriceLine, ProductsToBePricedId } from '../../types';
import { getClusterCellSkin, getClusterMetrics, getLineKey } from '../../utils';
import { NetworkPriceInputCell } from '../NetworkPriceInputCell';
import styles from './ClusterPriceCell.module.scss';

type ClusterPriceCellProps = { line: NetworkPriceLine; cluster: NetworkPriceCluster };

const EditableClusterPriceCell = ({ line, cluster, cellId }: ClusterPriceCellProps & { cellId: ProductsToBePricedId }) => {
  const draft = useClusterDraftPrice(cellId);
  // A network edit of the line locks its cluster cells until the line is reloaded.
  const isPending = useNetworkPricesStore(state => state.pendingCellIds.includes(cellId) || state.pendingLineKeys.includes(getLineKey(line)));
  const setDraftPrice = useNetworkPricesStore(state => state.setDraftPrice);
  const { commitClusterPrice } = useEditClusterPrice();
  const metrics = getClusterMetrics(cluster, draft ?? undefined);

  return (
    <NetworkPriceInputCell
      ariaLabel={`Preço de ${line.description} em ${cluster.clusterName}`}
      column={cluster.clusterId}
      value={draft === undefined ? cluster.price : draft}
      skin={getClusterCellSkin(cluster, draft)}
      variation={metrics.priceVariation}
      priceStatus={cluster.priceStatus}
      isPending={isPending}
      className={styles.bordered}
      onChange={value => setDraftPrice(cellId, value)}
      onCommit={() => commitClusterPrice(line, cluster)}
    />
  );
};

export const UnavailableClusterPriceCell = () => (
  <span className={styles.unavailable} title="Produto não disponível neste cluster">
    --
  </span>
);

export const ClusterPriceCell = ({ line, cluster }: ClusterPriceCellProps) => {
  if (cluster.productsToBePricedId === null) return <UnavailableClusterPriceCell />;

  return <EditableClusterPriceCell line={line} cluster={cluster} cellId={cluster.productsToBePricedId} />;
};
